import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { Texterror } from "../../../constants/Texterror";
import * as Yup from 'yup'; // Import Yup for validation if you're using it

export const EditModal = ({
  show,
  onHide,

}) => {
  const dispatch = useDispatch();
  const { currentData } = useSelector((state) => state.feeslist);

  const validationSchema = Yup.object().shape({
    svcfee_name: Yup.string().required('Name is required'),
    svcfee_desc: Yup.string().required('Description is required'),
    svcfee_amt: Yup.number().required('Amount is required'),
    svcfee_active_yn: Yup.string().required('Status is required'),
  });

  const handleSubmit = (values) => {
    // Assuming you have an action to handle the edit
    // dispatch(editFeesAction(values));
    onHide(); // Close modal after submit
  };

  const initialValues = {
    svcfee_name: currentData.svcfee_name || '',
    svcfee_desc: currentData.svcfee_desc || '',
    svcfee_amt: currentData.svcfee_amt || 0,
    svcfee_active_yn: currentData.svcfee_active_yn || 'Y',
  };
  return (
    <Modal className="edit_modal profile" show={show} onHide={onHide}>
      <Modal.Header closeButton><h5 className="mb-0">{`Edit Fees`}</h5></Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
        >
          {({ touched, errors, values, handleSubmit, setFieldValue }) => {
            return (
              <Form onSubmit={handleSubmit}>

                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Name</Form.Label>
                      <Field
                        className={`form-control ${touched.svcfee_name && errors.svcfee_name
                          ? "is-invalid"
                          : ""
                          }`}
                        name="svcfee_name"
                        placeholder="Service fee name"
                        type="input"
                        value={values.svcfee_name}
                      />
                      <ErrorMessage name="svcfee_name" component={Texterror} />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Amount</Form.Label>
                      <Field
                        className={`form-control ${touched.svcfee_amt && errors.svcfee_amt
                          ? "is-invalid"
                          : ""
                          }`}
                        name="svcfee_amt"
                        placeholder="Amount"
                        type="input"
                        value={values.svcfee_amt}
                      />
                      <ErrorMessage name="svcfee_amt" component={Texterror} />
                    </div>
                  </Col>

                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Status</Form.Label>
                      <Field name="svcfee_active_yn" className="form-select" as="select">
                        <option value="Y">Active</option>
                        <option value="N">Inactive</option>
                      </Field>
                      <ErrorMessage name="svcfee_active_yn" component={Texterror} />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Label>Description</Form.Label>
                      <Field name="svcfee_desc" as="textarea" rows="3" className="form-control"
                      />
                      <ErrorMessage name="svcfee_desc" component={Texterror} />
                    </div>
                  </Col>

                </Row>

                <Row>
                  <Col>
                    <div className="mini_edit">
                      <Button className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm" variant="secondary" onClick={onHide}>
                        Cancel
                      </Button>
                      <Button className="w-full !rounded-md !max-w-28 !text-sm !bg-primary-blue h-[43px] !border-primary-blue" variant="primary" type="submit">
                        Save
                      </Button>
                    </div>
                  </Col>
                </Row>{" "}
              </Form>
            );
          }}
        </Formik>
      </Modal.Body>

    </Modal>
  );
};
